import { render, staticRenderFns } from "./purchasepeople.vue?vue&type=template&id=c613e016"
import script from "./purchasepeople.vue?vue&type=script&lang=js"
export * from "./purchasepeople.vue?vue&type=script&lang=js"
import style0 from "./purchasepeople.vue?vue&type=style&index=0&id=c613e016&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports